/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".item[_ngcontent-%COMP%]{border-radius:1px;cursor:pointer;border:1px solid #eaeff5}.item--small[_ngcontent-%COMP%]{width:12px;height:12px}.item--medium[_ngcontent-%COMP%]{width:24px;height:24px}.item--large[_ngcontent-%COMP%]{width:36px;height:36px}.item--selected[_ngcontent-%COMP%]{border-color:#1c5ab9;border-width:2px}.item--transparent[_ngcontent-%COMP%]{background:linear-gradient(45deg,#f9fafd 48%,#de3838 50%,#f9fafd 52%)}"];
export { styles as styles };
